import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

const Body = styled.div`
    text-align: center;
`

const Header1 = styled.h1`
    font-size: 72pt;
    margin-block: 0;
    transition: ease all 1s;

    @media screen and (max-width: ${BREAKPOINTS.TABLET}) {
        font-size: 50pt;
    }

    @media screen and (max-width: ${BREAKPOINTS.MOBILE_L}) {
        font-size: 38pt;
    }
`

const MuffinError = styled.img`
    height: 15%;
    max-width: 350px;
    transition: ease all 1s;

    @media screen and (max-width: ${BREAKPOINTS.LAPTOP}) {
        max-width: 400px;
        width: unset;
    }

    @media screen and (max-width: ${BREAKPOINTS.TABLET}) {
        max-width: 250px;
        width: unset;
    }
`

const Text = styled.p`
    padding-inline: 0.5rem;
`

export default {
    Body,
    Header1,
    MuffinError,
    Text,
}
